module.exports = __webpack_public_path__ + "img/welding2.d0af0005.png";